var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"weixin",attrs:{"href":"https://docs.cuiqiu.com/docs/domain-email/%E5%AE%A2%E6%9C%8D%E5%B8%AE%E5%8A%A9/%E8%81%94%E7%B3%BB%E5%AE%A2%E6%9C%8D","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('lian-xi-ke-fu'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }